import { Component,ElementRef,input, OnInit } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { range } from 'underscore';

import { VbNestedMenuComponent } from '../shared/VbNestedMenuComponent';
import { SubtitleService } from '../Subtitle.Service';
import { ISubtitleDisplayOptions } from '../shared/SubtitleDisplayOptions';
import { SelectMenuComponent } from './SelectMenu.Component';

const availableColors = ['white', 'yellow', 'green', 'cyan', 'blue', 'purple', 'red', 'black'];

@Component({
	selector: 'subtitle-options-menu',
	templateUrl: './SubtitleOptionsMenu.Component.html',
	standalone: true,
	host: {
		class: 'submenuWrap'
	},
	imports: [
		BsDropdownModule,
		SelectMenuComponent
	],
	styleUrls: ['../VbPlayerSettingsMenu.Component.ng.less', '../MenuButton.ng.less']
})
export class SubtitleOptionsMenuComponent extends VbNestedMenuComponent implements OnInit {
	public readonly subtitleOptions = input.required<ISubtitleDisplayOptions>();
	public openMenuConfig: any;
	public menuConfigs: Record<string, any>;
	public selectedMenuValue: any;

	constructor(
		public readonly elementRef: ElementRef,
		public readonly SubtitleService: SubtitleService
	){
		super();
	}

	public ngOnInit(): void {
		super.ngOnInit();
		const colorOptions = availableColors.map(color => ({
			value: color,
			label: this.translations[color] || color
		}));

		const numberOptions = range(11).map(n => ({
			value: n / 10,
			label: `${n*10}%`
		}));

		const defaultOptions = this.subtitleOptions();
		this.menuConfigs = [
			{
				prop: 'fontColor',
				options: colorOptions,
				title: this.translations.fontColor,
				defaultValue: defaultOptions.fontColor || 'white'
			},
			{
				prop: 'fontSize',
				options: numberOptions.slice(1), //remove 0% font size option
				title: this.translations.fontSize,
				defaultValue: defaultOptions.fontSize || 0.4
			},
			{
				prop: 'backgroundColor',
				options: colorOptions,
				title: this.translations.backgroundColor,
				defaultValue: defaultOptions.backgroundColor || 'black'
			},
			{
				prop: 'backgroundOpacity',
				options: numberOptions,
				title: this.translations.backgroundOpacity,
				defaultValue: 0.8
			}
		];
	}

	protected updateDropdownState(): void {
		this.openMenuConfig = null;
		super.updateDropdownState();
	}

	public openSelectMenu(prop: string) {
		this.dropdown.hide();
		const subtitleOptions = this.SubtitleService.subtitleOptions();
		this.selectedMenuValue = subtitleOptions[prop];
		this.openMenuConfig = this.menuConfigs.find(c => c.prop === prop);
	}

	public updateSubtitleOptions(prop?: string, value?: any): void {
		const subtitleOptions = this.SubtitleService.subtitleOptions();
		this.SubtitleService.updateSubtitleOptions({
			...subtitleOptions,
			[prop]: value
		});
	}

	public hideSelectMenu(closeParent?: boolean): void {
		this.openMenuConfig = null;
		if(closeParent) {
			this.hideMenu(true);
			return;
		}
		setTimeout(() => {
			this.dropdown.show();
		}, 20);
	}

	public formatColor(color: string): string {
		return this.translations[color] ?? color;
	}

	public formatPercent(val: number): string {
		return `${Math.floor(val * 100)}%`;
	}

}
